import { cx } from '@otter-ai/den-components';
import { useTranslations } from 'next-intl';

export function TermsAgreementText({ className }: { className?: string }) {
  const t = useTranslations('auth.terms_agreement');

  return (
    <div
      className={cx('text-sm text-start sm:text-center text-subtle', className)}
    >
      <span>{t('user_agreement')} </span>
      <a
        data-testid="terms-of-service-link"
        target="_blank"
        rel="noopener noreferrer"
        href="https://otter.ai/terms-of-service"
        className="text-primary"
      >
        {t('terms_of_service')}
      </a>
      <span> {t('and')} </span>
      <a
        data-testid="privacy-policy-link"
        target="_blank"
        rel="noopener noreferrer"
        href="https://otter.ai/privacy-policy"
        className="text-primary"
      >
        {t('privacy_policy')}
      </a>
    </div>
  );
}
